import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import registerServiceWorker from './registerServiceWorker';
import createStore from './redux/store';

import { BrowserRouter as Router } from 'react-router-dom';
import { CookiesProvider, Cookies } from 'react-cookie';
import history from "./history";

import App from './Screens/App';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
 import './assets/mdb/mdb.css';
//import './assets/mdb/mdbFutureshift.css';
//import './assets/mdb/mdbIpea.css';
 try {
  console.log('SHOW ZENDESK')
  window.zE('messenger:set', 'zIndex', -10000)
  window.zE("messenger:on", "close", function () {
  window.zE('messenger:set', 'zIndex', -10000);
  })
} catch (error) {
  console.log('HIDE ZENDESK')
  window.zE && window.zE('webWidget', 'hide')
} 




ReactDOM.render(
  <CookiesProvider>
  <Provider store={createStore(window.__INITIAL_STATE__)}>
    <Router history={history}  basename="/student">
      <App />
    </Router>
  </Provider>
  </CookiesProvider>,
  document.querySelector('#root')
);



registerServiceWorker();
